import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  UrlTree
} from '@angular/router';
import { Observable, map } from 'rxjs';
import { AuthStateService } from '@sml/utility';

@Injectable({
  providedIn: 'root'
})
export class CustomTemplatePermissionGuard implements CanActivate {

  constructor(
    private authState: AuthStateService,
    private router: Router
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.authState.isEmailAllowedForTemplateActions().pipe(
      map(isAllowed => {
        if (isAllowed) {
          return true;
        } else {
          return this.router.createUrlTree(['/']);
        }
      })
    );
  }
}
